// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CFwPo","blockAnimate":"styles_blockAnimate__1xk2a","move":"styles_move__BVSOp"};